import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, MantineProvider, Table, Text } from "@mantine/core";
import { AuthProvider } from "./context/AuthProvider";
import classes from "./index.module.css";
import { GlobalProvider } from "./api/GlobalProvider";

const theme = createTheme({
  /** Put your mantine theme override here */
  components: {
    Text: Text.extend({
      classNames: {
        root: classes.text,
      },
    }),
  },
});


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <MantineProvider theme={theme}>
    {/* <React.StrictMode> */}
    <GlobalProvider>

      <AuthProvider>
        <App />
      </AuthProvider>
    </GlobalProvider>
    {/* </React.StrictMode> */}
  </MantineProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
